export default __webpack_public_path__ + "static/greenlights-2281df808391b337a00d5def65184416.jpg";